"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const static_colors_1 = __importDefault(require("../../global/static-colors"));
const spacing_1 = __importDefault(require("./spacing"));
const typography_1 = __importDefault(require("./typography"));
const output = {
    name: 'allhomes-light',
    spacing: spacing_1.default,
    typography: typography_1.default,
    colors: {
        neutral: {
            heavy: {
                default: static_colors_1.default.navy800,
                hover: static_colors_1.default.navy900,
                pressed: static_colors_1.default.navy900,
                selected: static_colors_1.default.navy900,
                disabled: static_colors_1.default.navy300,
            },
            medium: {
                default: static_colors_1.default.navy600,
                hover: static_colors_1.default.navy700,
                pressed: static_colors_1.default.navy800,
                selected: static_colors_1.default.navy900,
                disabled: static_colors_1.default.navy300,
            },
            base: {
                default: static_colors_1.default.navy500,
                hover: static_colors_1.default.navy600,
                pressed: static_colors_1.default.navy700,
                selected: static_colors_1.default.navy900,
                disabled: static_colors_1.default.navy300,
            },
            trim: {
                default: static_colors_1.default.navy300,
                hover: static_colors_1.default.navy400,
                pressed: static_colors_1.default.navy500,
                selected: static_colors_1.default.navy700,
                disabled: static_colors_1.default.navy200,
            },
            subdued: {
                default: static_colors_1.default.navy50,
                hover: static_colors_1.default.navy100,
                pressed: static_colors_1.default.navy200,
                selected: static_colors_1.default.navy50,
                disabled: static_colors_1.default.white,
            },
            surface: {
                default: static_colors_1.default.white,
                hover: static_colors_1.default.navy50,
                pressed: static_colors_1.default.navy100,
                selected: static_colors_1.default.white,
                disabled: static_colors_1.default.white,
            },
        },
        interactive: {
            heavy: {
                default: static_colors_1.default.pomegranate800,
                hover: static_colors_1.default.pomegranate900,
                pressed: static_colors_1.default.pomegranate900,
                selected: static_colors_1.default.pomegranate900,
                disabled: static_colors_1.default.navy300,
            },
            medium: {
                default: static_colors_1.default.pomegranate600,
                hover: static_colors_1.default.pomegranate700,
                pressed: static_colors_1.default.pomegranate800,
                selected: static_colors_1.default.pomegranate900,
                disabled: static_colors_1.default.navy300,
            },
            base: {
                default: static_colors_1.default.pomegranate500,
                hover: static_colors_1.default.pomegranate600,
                pressed: static_colors_1.default.pomegranate700,
                selected: static_colors_1.default.pomegranate900,
                disabled: static_colors_1.default.navy300,
            },
            trim: {
                default: static_colors_1.default.pomegranate300,
                hover: static_colors_1.default.pomegranate400,
                pressed: static_colors_1.default.pomegranate500,
                selected: static_colors_1.default.pomegranate700,
                disabled: static_colors_1.default.navy300,
            },
            subdued: {
                default: static_colors_1.default.pomegranate50,
                hover: static_colors_1.default.pomegranate100,
                pressed: static_colors_1.default.pomegranate200,
                selected: static_colors_1.default.pomegranate50,
                disabled: static_colors_1.default.white,
            },
            surface: {
                default: static_colors_1.default.white,
                hover: static_colors_1.default.pomegranate50,
                pressed: static_colors_1.default.pomegranate100,
                selected: static_colors_1.default.white,
                disabled: static_colors_1.default.white,
            },
        },
        primary: {
            heavy: {
                default: static_colors_1.default.pomegranate800,
                hover: static_colors_1.default.pomegranate900,
                pressed: static_colors_1.default.pomegranate900,
                selected: static_colors_1.default.pomegranate900,
                disabled: static_colors_1.default.pomegranate300,
            },
            medium: {
                default: static_colors_1.default.pomegranate600,
                hover: static_colors_1.default.pomegranate700,
                pressed: static_colors_1.default.pomegranate800,
                selected: static_colors_1.default.pomegranate900,
                disabled: static_colors_1.default.pomegranate300,
            },
            base: {
                default: static_colors_1.default.pomegranate500,
                hover: static_colors_1.default.pomegranate600,
                pressed: static_colors_1.default.pomegranate700,
                selected: static_colors_1.default.pomegranate900,
                disabled: static_colors_1.default.pomegranate300,
            },
            trim: {
                default: static_colors_1.default.pomegranate300,
                hover: static_colors_1.default.pomegranate400,
                pressed: static_colors_1.default.pomegranate500,
                selected: static_colors_1.default.pomegranate700,
                disabled: static_colors_1.default.pomegranate300,
            },
            subdued: {
                default: static_colors_1.default.pomegranate50,
                hover: static_colors_1.default.pomegranate100,
                pressed: static_colors_1.default.pomegranate200,
                selected: static_colors_1.default.pomegranate50,
                disabled: static_colors_1.default.white,
            },
            surface: {
                default: static_colors_1.default.white,
                hover: static_colors_1.default.pomegranate50,
                pressed: static_colors_1.default.pomegranate100,
                selected: static_colors_1.default.white,
                disabled: static_colors_1.default.white,
            },
        },
        secondary: {
            heavy: {
                default: static_colors_1.default.navy800,
                hover: static_colors_1.default.navy900,
                pressed: static_colors_1.default.navy900,
                selected: static_colors_1.default.navy900,
                disabled: static_colors_1.default.navy300,
            },
            medium: {
                default: static_colors_1.default.navy600,
                hover: static_colors_1.default.navy700,
                pressed: static_colors_1.default.navy800,
                selected: static_colors_1.default.navy900,
                disabled: static_colors_1.default.navy300,
            },
            base: {
                default: static_colors_1.default.navy500,
                hover: static_colors_1.default.navy600,
                pressed: static_colors_1.default.navy700,
                selected: static_colors_1.default.navy900,
                disabled: static_colors_1.default.navy300,
            },
            trim: {
                default: static_colors_1.default.navy300,
                hover: static_colors_1.default.navy400,
                pressed: static_colors_1.default.navy500,
                selected: static_colors_1.default.navy700,
                disabled: static_colors_1.default.navy300,
            },
            subdued: {
                default: static_colors_1.default.navy50,
                hover: static_colors_1.default.navy100,
                pressed: static_colors_1.default.navy200,
                selected: static_colors_1.default.navy50,
                disabled: static_colors_1.default.white,
            },
            surface: {
                default: static_colors_1.default.white,
                hover: static_colors_1.default.navy50,
                pressed: static_colors_1.default.navy100,
                selected: static_colors_1.default.white,
                disabled: static_colors_1.default.white,
            },
        },
        info: {
            heavy: {
                default: static_colors_1.default.navy800,
                hover: static_colors_1.default.navy900,
                pressed: static_colors_1.default.navy900,
                selected: static_colors_1.default.navy900,
                disabled: static_colors_1.default.navy300,
            },
            medium: {
                default: static_colors_1.default.navy600,
                hover: static_colors_1.default.navy700,
                pressed: static_colors_1.default.navy800,
                selected: static_colors_1.default.navy900,
                disabled: static_colors_1.default.navy300,
            },
            base: {
                default: static_colors_1.default.navy500,
                hover: static_colors_1.default.navy600,
                pressed: static_colors_1.default.navy700,
                selected: static_colors_1.default.navy900,
                disabled: static_colors_1.default.navy300,
            },
            trim: {
                default: static_colors_1.default.navy300,
                hover: static_colors_1.default.navy400,
                pressed: static_colors_1.default.navy500,
                selected: static_colors_1.default.navy700,
                disabled: static_colors_1.default.navy300,
            },
            subdued: {
                default: static_colors_1.default.navy50,
                hover: static_colors_1.default.navy100,
                pressed: static_colors_1.default.navy200,
                selected: static_colors_1.default.navy50,
                disabled: static_colors_1.default.white,
            },
            surface: {
                default: static_colors_1.default.white,
                hover: static_colors_1.default.navy50,
                pressed: static_colors_1.default.navy100,
                selected: static_colors_1.default.white,
                disabled: static_colors_1.default.white,
            },
        },
        success: {
            heavy: {
                default: static_colors_1.default.eucalyptus800,
                hover: static_colors_1.default.eucalyptus900,
                pressed: static_colors_1.default.eucalyptus900,
                selected: static_colors_1.default.eucalyptus900,
                disabled: static_colors_1.default.navy300,
            },
            medium: {
                default: static_colors_1.default.eucalyptus600,
                hover: static_colors_1.default.eucalyptus700,
                pressed: static_colors_1.default.eucalyptus800,
                selected: static_colors_1.default.eucalyptus900,
                disabled: static_colors_1.default.navy300,
            },
            base: {
                default: static_colors_1.default.eucalyptus500,
                hover: static_colors_1.default.eucalyptus600,
                pressed: static_colors_1.default.eucalyptus700,
                selected: static_colors_1.default.eucalyptus900,
                disabled: static_colors_1.default.navy300,
            },
            trim: {
                default: static_colors_1.default.eucalyptus300,
                hover: static_colors_1.default.eucalyptus400,
                pressed: static_colors_1.default.eucalyptus500,
                selected: static_colors_1.default.eucalyptus700,
                disabled: static_colors_1.default.navy300,
            },
            subdued: {
                default: static_colors_1.default.eucalyptus50,
                hover: static_colors_1.default.eucalyptus100,
                pressed: static_colors_1.default.eucalyptus200,
                selected: static_colors_1.default.eucalyptus50,
                disabled: static_colors_1.default.white,
            },
            surface: {
                default: static_colors_1.default.white,
                hover: static_colors_1.default.eucalyptus50,
                pressed: static_colors_1.default.eucalyptus100,
                selected: static_colors_1.default.white,
                disabled: static_colors_1.default.white,
            },
        },
        warning: {
            heavy: {
                default: static_colors_1.default.wattle800,
                hover: static_colors_1.default.wattle900,
                pressed: static_colors_1.default.wattle900,
                selected: static_colors_1.default.wattle900,
                disabled: static_colors_1.default.navy300,
            },
            medium: {
                default: static_colors_1.default.wattle600,
                hover: static_colors_1.default.wattle700,
                pressed: static_colors_1.default.wattle800,
                selected: static_colors_1.default.wattle900,
                disabled: static_colors_1.default.navy300,
            },
            base: {
                default: static_colors_1.default.wattle500,
                hover: static_colors_1.default.wattle600,
                pressed: static_colors_1.default.wattle700,
                selected: static_colors_1.default.wattle900,
                disabled: static_colors_1.default.navy300,
            },
            trim: {
                default: static_colors_1.default.wattle300,
                hover: static_colors_1.default.wattle400,
                pressed: static_colors_1.default.wattle500,
                selected: static_colors_1.default.wattle700,
                disabled: static_colors_1.default.navy300,
            },
            subdued: {
                default: static_colors_1.default.wattle50,
                hover: static_colors_1.default.wattle100,
                pressed: static_colors_1.default.wattle200,
                selected: static_colors_1.default.wattle50,
                disabled: static_colors_1.default.white,
            },
            surface: {
                default: static_colors_1.default.white,
                hover: static_colors_1.default.wattle50,
                pressed: static_colors_1.default.wattle100,
                selected: static_colors_1.default.white,
                disabled: static_colors_1.default.white,
            },
        },
        critical: {
            heavy: {
                default: static_colors_1.default.pomegranate800,
                hover: static_colors_1.default.pomegranate900,
                pressed: static_colors_1.default.pomegranate900,
                selected: static_colors_1.default.pomegranate900,
                disabled: static_colors_1.default.navy300,
            },
            medium: {
                default: static_colors_1.default.pomegranate600,
                hover: static_colors_1.default.pomegranate700,
                pressed: static_colors_1.default.pomegranate800,
                selected: static_colors_1.default.pomegranate900,
                disabled: static_colors_1.default.navy300,
            },
            base: {
                default: static_colors_1.default.pomegranate500,
                hover: static_colors_1.default.pomegranate600,
                pressed: static_colors_1.default.pomegranate700,
                selected: static_colors_1.default.pomegranate900,
                disabled: static_colors_1.default.navy300,
            },
            trim: {
                default: static_colors_1.default.pomegranate300,
                hover: static_colors_1.default.pomegranate400,
                pressed: static_colors_1.default.pomegranate500,
                selected: static_colors_1.default.pomegranate700,
                disabled: static_colors_1.default.navy300,
            },
            subdued: {
                default: static_colors_1.default.pomegranate50,
                hover: static_colors_1.default.pomegranate100,
                pressed: static_colors_1.default.pomegranate200,
                selected: static_colors_1.default.pomegranate50,
                disabled: static_colors_1.default.white,
            },
            surface: {
                default: static_colors_1.default.white,
                hover: static_colors_1.default.pomegranate50,
                pressed: static_colors_1.default.pomegranate100,
                selected: static_colors_1.default.white,
                disabled: static_colors_1.default.white,
            },
        },
        accentOne: {
            heavy: {
                default: static_colors_1.default.lavender800,
                hover: static_colors_1.default.lavender900,
                pressed: static_colors_1.default.lavender900,
                selected: static_colors_1.default.lavender900,
                disabled: static_colors_1.default.navy300,
            },
            medium: {
                default: static_colors_1.default.lavender600,
                hover: static_colors_1.default.lavender700,
                pressed: static_colors_1.default.lavender800,
                selected: static_colors_1.default.lavender900,
                disabled: static_colors_1.default.navy300,
            },
            base: {
                default: static_colors_1.default.lavender500,
                hover: static_colors_1.default.lavender600,
                pressed: static_colors_1.default.lavender700,
                selected: static_colors_1.default.lavender900,
                disabled: static_colors_1.default.navy300,
            },
            trim: {
                default: static_colors_1.default.lavender300,
                hover: static_colors_1.default.lavender400,
                pressed: static_colors_1.default.lavender500,
                selected: static_colors_1.default.lavender700,
                disabled: static_colors_1.default.navy300,
            },
            subdued: {
                default: static_colors_1.default.lavender50,
                hover: static_colors_1.default.lavender100,
                pressed: static_colors_1.default.lavender200,
                selected: static_colors_1.default.lavender50,
                disabled: static_colors_1.default.white,
            },
            surface: {
                default: static_colors_1.default.white,
                hover: static_colors_1.default.lavender50,
                pressed: static_colors_1.default.lavender100,
                selected: static_colors_1.default.white,
                disabled: static_colors_1.default.white,
            },
        },
        accentTwo: {
            heavy: {
                default: static_colors_1.default.pomegranate800,
                hover: static_colors_1.default.pomegranate900,
                pressed: static_colors_1.default.pomegranate900,
                selected: static_colors_1.default.pomegranate900,
                disabled: static_colors_1.default.navy300,
            },
            medium: {
                default: static_colors_1.default.pomegranate600,
                hover: static_colors_1.default.pomegranate700,
                pressed: static_colors_1.default.pomegranate800,
                selected: static_colors_1.default.pomegranate900,
                disabled: static_colors_1.default.navy300,
            },
            base: {
                default: static_colors_1.default.pomegranate500,
                hover: static_colors_1.default.pomegranate600,
                pressed: static_colors_1.default.pomegranate700,
                selected: static_colors_1.default.pomegranate900,
                disabled: static_colors_1.default.navy300,
            },
            trim: {
                default: static_colors_1.default.pomegranate300,
                hover: static_colors_1.default.pomegranate400,
                pressed: static_colors_1.default.pomegranate500,
                selected: static_colors_1.default.pomegranate700,
                disabled: static_colors_1.default.navy300,
            },
            subdued: {
                default: static_colors_1.default.pomegranate50,
                hover: static_colors_1.default.pomegranate100,
                pressed: static_colors_1.default.pomegranate200,
                selected: static_colors_1.default.pomegranate50,
                disabled: static_colors_1.default.white,
            },
            surface: {
                default: static_colors_1.default.white,
                hover: static_colors_1.default.pomegranate50,
                pressed: static_colors_1.default.pomegranate100,
                selected: static_colors_1.default.white,
                disabled: static_colors_1.default.white,
            },
        },
        accentThree: {
            heavy: {
                default: static_colors_1.default.sky800,
                hover: static_colors_1.default.sky900,
                pressed: static_colors_1.default.sky900,
                selected: static_colors_1.default.sky900,
                disabled: static_colors_1.default.navy300,
            },
            medium: {
                default: static_colors_1.default.sky600,
                hover: static_colors_1.default.sky700,
                pressed: static_colors_1.default.sky800,
                selected: static_colors_1.default.sky900,
                disabled: static_colors_1.default.navy300,
            },
            base: {
                default: static_colors_1.default.sky500,
                hover: static_colors_1.default.sky600,
                pressed: static_colors_1.default.sky700,
                selected: static_colors_1.default.sky900,
                disabled: static_colors_1.default.navy300,
            },
            trim: {
                default: static_colors_1.default.sky300,
                hover: static_colors_1.default.sky400,
                pressed: static_colors_1.default.sky500,
                selected: static_colors_1.default.sky700,
                disabled: static_colors_1.default.navy300,
            },
            subdued: {
                default: static_colors_1.default.sky50,
                hover: static_colors_1.default.sky100,
                pressed: static_colors_1.default.sky200,
                selected: static_colors_1.default.sky50,
                disabled: static_colors_1.default.white,
            },
            surface: {
                default: static_colors_1.default.white,
                hover: static_colors_1.default.sky50,
                pressed: static_colors_1.default.sky100,
                selected: static_colors_1.default.white,
                disabled: static_colors_1.default.white,
            },
        },
        accentFour: {
            heavy: {
                default: static_colors_1.default.wattle800,
                hover: static_colors_1.default.wattle900,
                pressed: static_colors_1.default.wattle900,
                selected: static_colors_1.default.wattle900,
                disabled: static_colors_1.default.wattle800,
            },
            medium: {
                default: static_colors_1.default.wattle600,
                hover: static_colors_1.default.wattle700,
                pressed: static_colors_1.default.wattle800,
                selected: static_colors_1.default.wattle900,
                disabled: static_colors_1.default.navy300,
            },
            base: {
                default: static_colors_1.default.wattle500,
                hover: static_colors_1.default.wattle600,
                pressed: static_colors_1.default.wattle700,
                selected: static_colors_1.default.wattle900,
                disabled: static_colors_1.default.navy300,
            },
            trim: {
                default: static_colors_1.default.wattle300,
                hover: static_colors_1.default.wattle400,
                pressed: static_colors_1.default.wattle500,
                selected: static_colors_1.default.wattle700,
                disabled: static_colors_1.default.navy300,
            },
            subdued: {
                default: static_colors_1.default.wattle50,
                hover: static_colors_1.default.wattle100,
                pressed: static_colors_1.default.wattle200,
                selected: static_colors_1.default.wattle50,
                disabled: static_colors_1.default.white,
            },
            surface: {
                default: static_colors_1.default.white,
                hover: static_colors_1.default.wattle50,
                pressed: static_colors_1.default.wattle100,
                selected: static_colors_1.default.white,
                disabled: static_colors_1.default.white,
            },
        },
        accentFive: {
            heavy: {
                default: static_colors_1.default.eucalyptus800,
                hover: static_colors_1.default.eucalyptus900,
                pressed: static_colors_1.default.eucalyptus900,
                selected: static_colors_1.default.eucalyptus900,
                disabled: static_colors_1.default.navy300,
            },
            medium: {
                default: static_colors_1.default.eucalyptus600,
                hover: static_colors_1.default.eucalyptus700,
                pressed: static_colors_1.default.eucalyptus800,
                selected: static_colors_1.default.eucalyptus900,
                disabled: static_colors_1.default.navy300,
            },
            base: {
                default: static_colors_1.default.eucalyptus500,
                hover: static_colors_1.default.eucalyptus600,
                pressed: static_colors_1.default.eucalyptus700,
                selected: static_colors_1.default.eucalyptus900,
                disabled: static_colors_1.default.navy300,
            },
            trim: {
                default: static_colors_1.default.eucalyptus300,
                hover: static_colors_1.default.eucalyptus400,
                pressed: static_colors_1.default.eucalyptus500,
                selected: static_colors_1.default.eucalyptus700,
                disabled: static_colors_1.default.navy300,
            },
            subdued: {
                default: static_colors_1.default.eucalyptus50,
                hover: static_colors_1.default.eucalyptus100,
                pressed: static_colors_1.default.eucalyptus200,
                selected: static_colors_1.default.eucalyptus50,
                disabled: static_colors_1.default.white,
            },
            surface: {
                default: static_colors_1.default.white,
                hover: static_colors_1.default.eucalyptus50,
                pressed: static_colors_1.default.eucalyptus100,
                selected: static_colors_1.default.white,
                disabled: static_colors_1.default.white,
            },
        },
    },
};
exports.default = output;
//# sourceMappingURL=allhomes.js.map